import React, { useCallback, useEffect, useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

import {
  getUserDashboard,
  getUserDashboardStatus,
} from "../../../helpers/backend_helper";
import ReactSelect from "react-select";

const UserDashboard = () => {
  const { route_slug } = useParams();
  const [interval, setInterval] = useState([]);

  const [branches, setBranches] = useState([]);
  const [geofences, setGeofences] = useState([]);
  const [targets, setTargets] = useState(null);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedGeofence, setSelectedGeofence] = useState(null);
  const [selectedGeofence2, setSelectedGeofence2] = useState(null);
  const [selectedTarget, setSelectedTarget] = useState(null);

  const [route, setRoute] = useState();
  const [error, setError] = useState("");
  const [resultA, setResultA] = useState([]);
  const [resultADestine, setResultADestine] = useState('');
  const [resultB, setResultB] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingStatus, setIsLoadingStatus] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(100);

  const fetchUserDashboarInit = useCallback(async () => {
    try {
      const response = await getUserDashboard(route_slug);
      setRoute(response.route);
      setBranches(response.route.branches);
    } catch (error) {
      setError(error?.message ?? "Error desconocido");
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const getStatus = async () => {
    try {
        setIsLoadingStatus(true);
      if (selectedGeofence || selectedTarget) {
        const response = await getUserDashboardStatus(route_slug, {
          params: {
            branch: selectedBranch.value,
            branchGeofence: selectedGeofence,
            geofenceStart: selectedGeofence2,
            geofenceTarget: selectedTarget,
          },
        });
        setResultA(response?.resultA ? response?.resultA.reverse() : []);
        setResultB(response?.resultB ?? []);
      }
    } catch (error) {
      setError(error?.message ?? "Error desconocido");
      console.log(error);
    } finally {
        setIsLoadingStatus(false);
    }
  };

  useEffect(() => {
    fetchUserDashboarInit();
  }, []);

  useEffect(() => {
    if (selectedBranch) {
      setGeofences(
        branches.find((branch) => branch.id === selectedBranch?.value).geofences
      );
      setSelectedGeofence(null);

      const branch = branches.find((branch) => branch.id === selectedBranch?.value)
      setResultADestine(branch.geofences[branch.geofences.length - 1].geo.name)      
    }
  }, [selectedBranch]);

  useEffect(() => {
    if (selectedGeofence2) {
      console.log(selectedGeofence2);
      let targets = branches.filter((branch) => {
        let a = branch.geofences.find(
          (geofence) => geofence.geo.id === selectedGeofence2
        );
        console.log(a);
        return a != null ? true : false;
      });
      console.log("targets", targets);

      let finalTargets = {};
      targets?.forEach((target) => {
        finalTargets[target.geofences[target.geofences.length - 1].geo.name] = {
          label: target.geofences[target.geofences.length - 1].geo.name,
          value: target.id,
        };
      });

      setTargets(Object.values(finalTargets));
      setSelectedTarget(null);
    }
  }, [selectedGeofence2]);

  useEffect(() => {
    clearInterval(interval);
    const newInterval = setInterval(() => {
      getStatus();
    }, 1000 * 60 * 1);

    setInterval(newInterval);

    return () => clearInterval(interval);
  }, [selectedBranch, selectedGeofence, selectedGeofence2, selectedTarget]);

  useEffect(() => {
    getStatus();
  }, [selectedGeofence, selectedGeofence2, selectedTarget]);

  if (isLoading)
    return (
      <div>
        <div className="maintenance-cog-icon text-primary pt-4 text-center">
          <i className="mdi mdi-cog spin-right display-3"></i>
          <i className="mdi mdi-cog spin-left display-4 cog-icon"></i>
          <p className="text-dark"></p>
          <h3 className="mt-4">Cargando información de la ruta</h3>
          <p className="text-dark">Espere un momento por favor</p>
        </div>
      </div>
    );

  if (!route)
    return (
      <p className="text-center py-4">No se encontro información de la ruta</p>
    );

  if (error) return <p className="text-center py-4">Error: {error}</p>;

  return (
    <React.Fragment>
      <div className="bg-soft-light min-vh-100">
        <div className="bg-primary py-3">
          <Container fluid={true}>
            <div className="row">
              <div className="col-12 col-md-4 text-center text-md-start">
                <span className="logo-txt pe-2">GoGoTrack</span>
              </div>
              <div className="col-12 col-md-4">
                <h4 className="fw-medium display-7 mb-0  text-center">
                  {route?.name}
                </h4>
              </div>
              <div className="col-12 col-md-4 text-center text-md-end">
                {isRefreshing ? (
                  <div className="text-end pe-2">
                    <Spinner />
                  </div>
                ) : (
                  <div className="text-end pe-2">
                    <p className="mb-0"></p>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </div>
        <div className="py-2">
          <Container fluid={true}>
            { isLoadingStatus && <Spinner color="primary" className="spinner-lg" />}
            <Row>
              <Col sm={12} className="p-4">
                <div className="mb-3">
                  <Label>Selecciona un ramal</Label>
                  <ReactSelect
                    options={branches.map((branch) => {
                      return { label: branch.name, value: branch.id };
                    })}
                    onChange={(option) => setSelectedBranch(option)}
                    placeholder="Seleccionar..."
                  ></ReactSelect>
                </div>

                <div className="">
                  <Label>Selecciona una geocerca</Label>
                  <ReactSelect
                    options={geofences.map((geofence) => {
                      return {
                        label: `${geofence.position} ${geofence.geo.name}`,
                        value: geofence.id,
                      };
                    })}
                    onChange={(option) => setSelectedGeofence(option.value)}
                    placeholder="Seleccionar..."
                  ></ReactSelect>
                </div>

                <div className="mt-3">
                  <table className="table table-sm text-center">
                    <thead className="table-light">
                      <tr>
                        <th colSpan={3}>Unidades por llegar a la geocerca</th>
                      </tr>
                      <tr>
                        <th>Unidad</th>
                        <th>Tiempo llegada</th>
                        <th>Destino</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(resultA || []).map((result, index) => (
                        <tr key={index}>
                          <td>{result.unit?.number ?? "-"}</td>
                          <td>
                            {result.unit?.eta
                              ? Number(result.unit?.eta).toFixed(0)
                              : "-"}{" "}
                            min.
                          </td>
                          <td>{resultADestine ?? '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col sm={6} className="p-4 d-none">
                <div className="mb-3">
                  <Label>Selecciona una geocerca</Label>
                  <ReactSelect
                    options={route.geofences.map((geofence) => {
                      return {
                        label: geofence.name,
                        value: geofence.id,
                      };
                    })}
                    onChange={(option) => setSelectedGeofence2(option.value)}
                    placeholder="Seleccionar..."
                  ></ReactSelect>
                </div>
                <div className="mb-3">
                  <Label>Destino</Label>
                  <ReactSelect
                    options={targets}
                    placeholder="Seleccionar..."
                    onChange={(option) => setSelectedTarget(option.value)}
                  ></ReactSelect>
                </div>

                <div className="mt-3">
                  <table className="table table-sm text-center">
                    <thead className="table-light">
                      <tr>
                        <th colSpan={2}>Inicio - Destino</th>
                      </tr>
                      <tr>
                        <th>Unidad</th>
                        <th>Tiempo llegada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>10</td>
                        <td>6 minutos</td>
                      </tr>
                      <tr>
                        <td>23</td>
                        <td>10 minutos</td>
                      </tr>
                      <tr>
                        <td>56</td>
                        <td>18 minutos</td>
                      </tr>
                      <tr>
                        <td>22</td>
                        <td>27 minutos</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserDashboard;
